import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { clearAuth } from '../store/slices/authSlice';
import '../config/firebase';

const AuthContext = createContext(null);
const AUTH_STORAGE_KEY = 'trakna_auth_state';

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const auth = getAuth();
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {  
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {

      setCurrentUser(user);
      
      if (user) {
        const userData = {
          uid: user.uid,
          numero: user.phoneNumber,
          email: user.email,
          token: user.accessToken
        };
        
        // Mettre à jour le localStorage
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(userData));
        
      } else {
        localStorage.removeItem(AUTH_STORAGE_KEY);
        setCurrentUser(null);
        dispatch(clearAuth());
        console.log('AuthContext - User logged out, cleared auth state');
      }
    });

    return () => {
      console.log('AuthContext - Cleaning up auth listener');
      unsubscribe();
    };
  }, [dispatch, auth]);

  const value = {
    auth,
    currentUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
